import type { SxProps, Theme } from '@mui/material/styles';
import {
  TABLE_ACTION_ICON_COLOR,
  tableActionIconButtonSx,
} from '../../styles/theme/tableActionIcons';

/**
 * Product catalog CTA gradient (e.g. delete toolbar actions).
 * Prefer keeping usage aligned with catalog / CRM primary actions.
 */
export const CATALOG_CTA_GRADIENT = 'linear-gradient(to right, #2D63ED, #14B39B)';

export const CATALOG_CTA_GRADIENT_HOVER = 'linear-gradient(to right, #2557d8, #129e87)';

/** Action column icons: solid table action blue (#2563eb). */
export const catalogActionIconButtonSx: SxProps<Theme> = tableActionIconButtonSx;

/** Solid fill for catalog row-action icons (gradient defs kept for API compatibility). */
export function catalogActionSvgIconGradientSx(_gradientDomId: string): SxProps<Theme> {
  return {
    color: TABLE_ACTION_ICON_COLOR,
    '& path': { fill: 'currentColor' },
    '& circle': { fill: 'currentColor' },
    '& rect': { fill: 'currentColor' },
    '& polygon': { fill: 'currentColor' },
  };
}
